export default function ($) {
  var servicesList = $('.js-service-list');
  var highlightOutService = function( service ) {
    service.find('.service-icon').removeClass('bg-primary-light');
    service.find('.service-icon').addClass('bg-primary');
  };

  var highlightInService = function( service ) {
    service.find('.service-icon').addClass('bg-primary-light');
    service.find('.service-icon').removeClass('bg-primary');
  };
  servicesList.each(function() {
    var first = $(this).find('.js-service').first(),
    service = $(this).children('.js-service');

    highlightInService(first);
    $('.js-service-link').on('click', function(e){
      highlightOutService(service);
      highlightInService($(this));
    });
  });
  $('.js-service-link').on('click', function(e){

    if( $(window).outerWidth() >= 1024 ){
      e.preventDefault()
      e.stopPropagation()
      var imgSrc = $(this).data('image'),
          imageSrcset = $(this).data('imagesrcset'),
          textSrc = $(this).data('text'),
          buttonSrc = $(this).data('button'),
          buttonHref = $(this).attr('href');

      $('#js-service-image').attr('src', imgSrc);
      $('#js-service-image').attr('srcset', imageSrcset);
      $('#js-service-text').text(textSrc);
      $('#js-service-button').text(buttonSrc);
      $('#js-service-button').attr('href', buttonHref);

    }
  });
}
